import { render, staticRenderFns } from "./BaseCommonPage.vue?vue&type=template&id=5bafdbb3&"
import script from "./BaseCommonPage.vue?vue&type=script&lang=js&"
export * from "./BaseCommonPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseCommonPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports